import React from 'react'
import ReactLogo from './ping-logo-horizontal-color.svg'

const PingOneLogo = ({ className = '' }) => {
  return <img className={className} src={ReactLogo} />
}

export { PingOneLogo }
